import React from "react";
import { Helmet } from "react-helmet";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import NotTakingReportTable from "./components/NotTakingReportTable";
import NotTakingStudentTable from "./components/NotTakingStudentTable";

const useStyles = makeStyles({
  title: {
    marginTop: 10,
  },
});

const NotTakingsList = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Not Takings</title>
      </Helmet>

      <SanitizedGrid>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            Not Takings By Parent (Report)
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <NotTakingReportTable />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            Exclude Students (Not Takings By Routeplanner)
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <NotTakingStudentTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default NotTakingsList;
